import React, { Component, useLayoutEffect, useState } from "react";
import moment from "moment";
import {
  Show,
  TabbedShowLayout,
  Tab,
  ImageField,
  FileField,
  TextField,
  BooleanField,
  TopToolbar,
  SaveButton,
  RefreshButton,
  ListButton,
  EditButton,
  ReferenceManyField,
  DateField,
  Datagrid,
  ReferenceField,
  SimpleForm,
  Toolbar,
  FormDataConsumer,
  GET_ONE,
  useTranslate,
  useRecordContext
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { getLocalStorageKey } from "../common/common";
import Modal from "react-responsive-modal";
import noImage from "./../images/combined-shape.svg";
import Spinner from "../../src/spinner";
import myDataProvider from "../myRestProvider";
// const topToolbarStyle = {
//   zIndex: 2,
//   display: "inline-block",
//   float: "right"
// };

const ShowTitle = () => {
  const record = useRecordContext();
  return <span>Record - {record ? `${record.complaint_number}` : ""}</span>;
};

const newTab = (url) => {
  window.open(url, "_blank");
};

const styles = {
  image: {
    height: 50,
    width: 50,
  },
};

const ShowActions = ({ permissions, basePath, data, resource }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

const ShowForm = () => {
  // let fileSizeValidation = false;
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     fileSizeValidation: false,
  //     fileTypeValidation: false,
  //     fileExtensionValidation: false,
  //     open: false,
  //   };
  // }

  // These states are unused...need to remove (By Aniket Raut)

  // const [fileSizeValidation, setFileSizeValidation] = useState(false);
  // const [fileTypeValidation, setFileTypeValidation] = useState(false);
  // const [fileExtensionValidation, setFileExtensionValidation] = useState(false);
  // const [open, setOpen] = useState(false);

  let adminFileAaayCount = [];
  let businessFileAaayCount = [];
  const showReferenceNo = getLocalStorageKey("show_reference_no");
  const translate = useTranslate();

  return (
    <div>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          console.log("formData", formData);
          if (formData) {
            return (
              <div className="status-table">
                <p className="complaint-details-label">
                  {translate("resources.complaints.fields.record_details")}
                </p>
                <div className="complaint-showpage-container">
                  <div className="complaint-showpage-item">
                    <p>
                      {translate("resources.complaints.fields.business_name")}
                    </p>
                    {formData.business_name}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>
                      {translate(
                        "resources.complaints.fields.business_sap_code"
                      )}
                    </p>
                    {formData.sap_code}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>{translate("resources.complaints.fields.user_id")}</p>
                    <ReferenceField
                      label="User name"
                      source="user_id"
                      reference="users"
                      link="show"
                      allowEmpty
                    >
                      <TextField source="first_name" />
                    </ReferenceField>
                  </div>

                  <div className="complaint-showpage-item">
                    <p>
                      {translate("resources.complaints.fields.complaint_type")}
                    </p>
                    {formData.comp_type}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>
                      {translate(
                        "resources.complaints.fields.complaint_number"
                      )}
                    </p>
                    {formData.complaint_number}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>
                      {translate("resources.complaints.fields.category_name")}
                    </p>
                    {formData.complaint_category_name}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>
                      {translate(
                        "resources.complaints.fields.subcategory_name"
                      )}
                    </p>
                    {formData.subcategory_name}
                  </div>
                  {showReferenceNo && showReferenceNo.show && (
                    <div className="complaint-showpage-item">
                      <p>
                        {translate("resources.complaints.fields.ref_number")}
                      </p>
                      {formData.reference_number}
                    </div>
                  )}
                  <div className="complaint-showpage-item">
                    <p>
                      {translate(
                        "resources.complaints.fields.complaint_status"
                      )}
                    </p>
                    {formData.complaint_status}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>{translate("resources.complaints.fields.created_at")}</p>
                    {moment(formData.created_at).format(
                      "MM/DD/YYYY, H:mm:ss a"
                    )}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>
                      {translate("resources.complaints.fields.customer_desc")}
                    </p>
                    {formData.description}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>
                      {translate(
                        "resources.complaints.fields.customer_service"
                      )}
                    </p>
                    {formData.comment}
                  </div>
                </div>

                <div className="complaint-files-onshow">
                  {formData.complaint_files &&
                  formData.complaint_files.length === 0 ? (
                    <div>
                      <div className="complaint-files-label">
                        {translate("resources.complaints.fields.file_uploaded")}
                      </div>
                      <p className="no-files-uploaded">
                        {translate(
                          "resources.complaints.fields.no_file_uploaded"
                        )}
                      </p>
                    </div>
                  ) : (
                    <div className="complaint-files">
                      <div className="complaint-files-label">
                        {translate("resources.complaints.fields.file_uploaded")}
                      </div>
                      <div className="upload-file-section">
                        <div className="files-uploaded">
                          <div className="files-uploaded-section">
                            <p className="uploaded-files-label">
                              {translate(
                                "resources.complaints.fields.customer_files"
                              )}
                            </p>
                            <div className="uploaded-files-container">
                              {formData.complaint_files &&
                                formData.complaint_files
                                  .filter((file) => file.file_url != null)
                                  .map((file) => {
                                    // record.complaint_files && record.complaint_files.map(file => {
                                    console.log(
                                      "files,,,,",
                                      file.principle_type
                                    );

                                    if (file.principle_type === "Business") {
                                      businessFileAaayCount.push(
                                        file.principle_type
                                      );
                                    }

                                    return (
                                      <div
                                        className="complaint-file-content"
                                        onClick={() => {
                                          newTab(file.file_url);
                                        }}
                                      >
                                        {file.principle_type === "Business" && (
                                          <div>
                                            {/* <button onClick={() => { deleteFilePop(file); }}>X</button> */}
                                            {file.file_url_data.file_type ===
                                            "image" ? (
                                              <img
                                                src={file.file_url}
                                                title={
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              />
                                            ) : (
                                              <img
                                                src={noImage}
                                                title={
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              />
                                            )}
                                            <p
                                              title={
                                                file.file_url_data.metadata
                                                  .filename
                                              }
                                            >
                                              {
                                                file.file_url_data.metadata
                                                  .filename
                                              }
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                              {businessFileAaayCount.length <= 0 && (
                                <p className="no-files-uploaded">
                                  {translate(
                                    "resources.complaints.fields.no_file_uploaded"
                                  )}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="files-uploaded-section">
                            <p className="uploaded-files-label">
                              {translate(
                                "resources.complaints.fields.customer_service_files"
                              )}
                            </p>
                            <div className="uploaded-files-container">
                              {
                                //  record.complaint_files && record.complaint_files.map(file => {
                                formData.complaint_files &&
                                  formData.complaint_files
                                    .filter((file) => file.file_url != null)
                                    .map((file) => {
                                      console.log(
                                        "files,,,,",
                                        file.principle_type
                                      );

                                      if (
                                        file.principle_type === "AdminPanelUser"
                                      ) {
                                        adminFileAaayCount.push(
                                          file.principle_type
                                        );
                                      }
                                      return (
                                        <div
                                          className="complaint-file-content"
                                          onClick={() => {
                                            newTab(file.file_url);
                                          }}
                                        >
                                          {file.principle_type ===
                                            "AdminPanelUser" && (
                                            <div>
                                              {file.file_url_data.file_type ===
                                              "image" ? (
                                                <img
                                                  src={file.file_url}
                                                  title={
                                                    file.file_url_data.metadata
                                                      .filename
                                                  }
                                                />
                                              ) : (
                                                <img
                                                  src={noImage}
                                                  title={
                                                    file.file_url_data.metadata
                                                      .filename
                                                  }
                                                />
                                              )}
                                              <p
                                                title={
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              >
                                                {
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })
                              }
                              {adminFileAaayCount.length <= 0 && (
                                <p className="no-files-uploaded">
                                  {translate(
                                    "resources.complaints.fields.no_file_uploaded"
                                  )}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          }
        }}
      </FormDataConsumer>
    </div>
  );
};

const EditToolbar = (props) => (
  <div></div>
  // <Toolbar {...props} >
  //   <SaveButton />
  // </Toolbar>
);

const ComplaintManagementsShow = (props) => (
  <Show {...props} title={<ShowTitle />} actions={<ShowActions />}>
    <SimpleForm toolbar={<EditToolbar />}>
      <ShowForm />
    </SimpleForm>
  </Show>
);

export default ComplaintManagementsShow;
